import { render, staticRenderFns } from "./PraticaAereoExtension.vue?vue&type=template&id=0ec73c98&"
import script from "./PraticaAereoExtension.vue?vue&type=script&lang=js&"
export * from "./PraticaAereoExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec73c98')) {
      api.createRecord('0ec73c98', component.options)
    } else {
      api.reload('0ec73c98', component.options)
    }
    module.hot.accept("./PraticaAereoExtension.vue?vue&type=template&id=0ec73c98&", function () {
      api.rerender('0ec73c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaAereoExtension.vue"
export default component.exports